import { infiniteQueryOptions } from '@tanstack/react-query';

import { AuthInfiniteQueryOptions, UnauthInfiniteQueryOptions } from '@/api/v2';

interface PolicyInfoListOptionsProps {
  isLogin: boolean | undefined;
  keyword?: string;
  policySort?: 'LATEST' | 'POPULARITY';
  codeProvisionType?: string;
}

export const policyInfoQueryOptions = {
  list: ({
    isLogin,
    policySort = 'LATEST',
    keyword,
    codeProvisionType,
  }: PolicyInfoListOptionsProps) => {
    const INITIAL_PAGE = 1;
    const PAGE_SIZE = 20;

    return infiniteQueryOptions({
      ...(isLogin
        ? AuthInfiniteQueryOptions['get:/wello/v2/auth/contents/best']
        : UnauthInfiniteQueryOptions['get:/wello/v2/allows/contents/best'])({
        query: {
          size: PAGE_SIZE,
          search_keyword: keyword,
          best_contents_sort: policySort,
          code_provision_type: codeProvisionType,
          page: INITIAL_PAGE,
        },
      }),
      getNextPageParam: ({ context }) => {
        const { total_count, page } = context ?? {};

        if (!total_count || !page) return;

        const nextPage = page + 1;
        const totalPageCount = Math.ceil(total_count / PAGE_SIZE);

        if (nextPage <= totalPageCount) return nextPage;
      },
      select: ({ pages }) =>
        pages.map(({ context }) => ({
          policyInfoList: context?.contents?.map(
            ({ provision_type, ...content }) => {
              const provisionTypeList: string[] = [];

              for (const key in provision_type) {
                const value = provision_type[key];
                if (value) provisionTypeList.push(value);
              }

              return { ...content, provisionTypeList };
            },
          ),
          totalCount: context?.total_count,
        })),
      initialPageParam: INITIAL_PAGE,
    });
  },
};
